import MidiEffect from '../MidiEffect.js';
import {VoiceTransformEffect} from './ChordEffects.js';
import Tone from 'tone';

let TIME_32N = new Tone.Time('32n');

// TODO: move this to a new FlowEffects file
export class SplitEffect extends MidiEffect {
    constructor(track) {
        super("Split", track);
        this.numberOfOutputs = 2;
    }

    set value(x) {
        if (x > 0) {
            this.numberOfOutputs = x;
        }
    }

    get value() {
        return this.numberOfOutputs;
    }

    getText() {
        return this.numberOfOutputs;
    }

    getJson() {
        return {
            ... super.getJson(),
            numberOfOutputs: this.numberOfOutputs
        };
    }

    fromJson(json) {
        super.fromJson(json);
        if (json.numberOfOutputs) {
            this.numberOfOutputs = json.numberOfOutputs;
        }
    }

    output(time, stepNumber) {
        let triggers = [];

        for (let trigger of this.triggers) {
            let {stepData, time} = trigger;
            let dur = stepData.duration;
            stepData.duration = dur/this.numberOfOutputs;
            triggers.push(trigger);

            for (let i=1; i < this.numberOfOutputs; i++) {
                let newTrigger = this.copyTrigger(trigger);
                time += TIME_32N*(dur/(this.numberOfOutputs/2));
                newTrigger.time = time;
                newTrigger.outputNumber = i;
                triggers.push(newTrigger);
            }
        }
        return triggers;
    }
}

export class FlatEffect extends VoiceTransformEffect {
    constructor(track) {
        super("Flat", track);

        this.value = 1;
    }

    output() {
        let triggers = this.triggers || [];
        this.active = triggers.length > 0;

        for (let trigger of triggers) {
            trigger.stepData.voices.forEach(
                v => v.flat = this.value);
        }

        return triggers;
    }
}

export class ThickEffect extends VoiceTransformEffect {
    constructor(track) {
        super("Thick", track);

        this.value = 1;
    }

    output() {
        let triggers = this.triggers || [];
        this.active = triggers.length > 0;

        for (let trigger of triggers) {
            trigger.stepData.voices.forEach(
                v => v.thick = this.value);
        }

        return triggers;
    }
}

